import { getApiKey } from "../../utils/apiKey";
import Header from "../header";
import axios from "axios";
import { apiCall_domain } from "../api";
import React, { Component } from "react";
import PulseLoader from "react-spinners/PulseLoader";
var foo;
class ReplyTicket extends Component {
  state = {
    selectImage: null,
    textAreaValue: null,
    inputValue: null,
    secInputValue: null,
    loader: false,
    imageUrl: null,
    uploadedImages: [],
    error: "",
    sendTicket: "",
  };

  inputChanges = (event) => {
    this.setState({ inputValue: event.target.value });
  };
  render() {
    const imageUploadChanges = (e, id, name) => {
      this.setState({ selectImage: e.target.files[0] });
    };
    const ReturnPic = () => {
      var binaryData = [this.state.selectImage];
      foo = URL.createObjectURL(new Blob(binaryData, { type: "image/png" }));
      return <img className="UploadedImgCertificate" src={foo} alt="pic" />;
    };

    const texrAreaChanges = (event) => {
      this.setState({ textAreaValue: event.target.value });
    };

    const uploadFile = (file) => {
      const headers = {
        Authorization: getApiKey(),
      };
      const formData = new FormData();
      formData.append("file", file);
      return axios.post(`${apiCall_domain}/customer/store-file`, formData, {
        headers: headers,
      });
    };
    const uploadImage = async () => {
      return new Promise((resolve, reject) => {
        uploadFile(this.state.selectImage).then((res) => {
          this.setState({ uploadedImages: res.data.name });
          resolve();
        });
      });
    };
    const sendTicket = () => {
      if (this.state.inputValue === null) {
        this.setState({ error: "لطفا فیلد عنوان را کامل کنید" });
      } else if (this.state.textAreaValue === null) {
        this.setState({ error: "لطفا سوال خود را شرح دهید" });
      } else if (this.state.selectImage) {
        this.setState({ loading: true });
        uploadImage().then((res) => {
          const data = {
            title: this.state.inputValue,
            text: this.state.textAreaValue,
            pic: this.state.uploadedImages,
          };
          const headers = {
            Authorization: getApiKey(),
            "content-type": "application/json",
          };
          axios
            .post(
              `${apiCall_domain}/customer/user/tickets/${localStorage.getItem(
                "ticketDetailsIdUser",
              )}`,
              data,
              {
                headers,
              },
            )
            .then((res) => {
              this.setState({ sendTicket: res.data.message }, () => {
                localStorage.setItem("sendTicket", 1);
                this.props.history.push("/showMore/Support");
              });
            });
        });
      } else {
        this.setState({ loading: true });

        const data = {
          text: this.state.textAreaValue,
        };
        const headers = {
          Authorization: getApiKey(),
          "content-type": "application/json",
        };
        axios
          .post(
            `${apiCall_domain}/customer/user/tickets/${localStorage.getItem(
              "ticketDetailsIdUser",
            )}`,
            data,
            {
              headers,
            },
          )
          .then((res) => {
            this.setState({ sendTicket: res.data.message }, () => {
              localStorage.setItem("sendTicket", 1);
              this.props.history.push("/showMore/Support");
            });
          });
      }
    };

    return (
      <>
        <Header showSearchBar={true} title={"پاسخ تیکت"} />
        <div className="TicketMain">
          <div className="innerTicketMain">
            <div className="inputsRow inputsRowFirst">
              <input
                type="text"
                placeholder="عنوان   "
                className="ticketInput"
                onChange={(e) => this.inputChanges(e)}
              />
            </div>
            <div className="inputsRow inputsRowFirst"></div>
            <div className="inputsRow textAreaRow">
              <textarea
                type="text"
                placeholder=" پاسخ خود را بنویسید ..."
                className="ticketInput"
                onChange={(e) => texrAreaChanges(e)}
              />
            </div>
            <div className="fileUpload">
              <div className="mainUpload">
                <input
                  type="file"
                  onChange={(e) => imageUploadChanges(e, 1, "1عکس")}
                  onClick={() => this.setState({ loader: true })}
                />
              </div>
              <div className="fileUploadP">
                {!this.state.selectImage ? (
                  <span>افزودن تصویر</span>
                ) : (
                  ReturnPic(1)
                )}
              </div>
            </div>
          </div>
          <div className="error">{this.state.error}</div>
          <div className="successfulTicket">{this.state.sendTicket}</div>
          <div className="ticketButton">
            <button
              className="mainTicketButton"
              type="submit"
              onClick={() => sendTicket()}
            >
              {this.state.loading ? (
                <PulseLoader color={"white"} />
              ) : (
                "ارسال تیکت"
              )}
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default ReplyTicket;
